import { useEffect } from 'react';
import useTracking from './use-tracking';
import summarizeAssignments from './assignment-summary';
import { startAssignmentFlow, resetAssignmentFlow } from './assignment-flow';

// Selection changes come from many grid actions, so the footer watches the
// derived "to assign" list: the first selection starts a flow, an empty list
// resets it. dueDate is the saved due date preference at that moment; source
// and action are only known for one-click flows, so they are sent as null.
export default function useAssignmentFlowStart(assignmentsToAssign, dueDate) {
  const { trackAssignmentFlowStarted } = useTracking();

  useEffect(() => {
    if (assignmentsToAssign.length === 0) {
      resetAssignmentFlow();
      return;
    }
    if (startAssignmentFlow()) {
      trackAssignmentFlowStarted({
        type: 'assign',
        target: 'students',
        dueDate,
        ...summarizeAssignments(assignmentsToAssign)
      });
    }
  }, [assignmentsToAssign, dueDate, trackAssignmentFlowStarted]);
}



// WEBPACK FOOTER //
// ./analytics/tracking/use-assignment-flow-start.js